var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle124A = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 108 48",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M17.794 3.274A2.5 2.5 0 0 1 20.284 1h5.434a2.5 2.5 0 0 1 2.49 2.274l.545 6A2.5 2.5 0 0 1 26.263 12h-6.525a2.5 2.5 0 0 1-2.49-2.726l.546-6Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M19.738 2c-.686 0-1.314.388-1.62 1.002l-.223.445a1 1 0 1 1-1.79-.894l.223-.446A3.813 3.813 0 0 1 19.738 0h6.524c1.444 0 2.764.816 3.41 2.107l.223.446a1 1 0 1 1-1.79.894l-.222-.445A1.812 1.812 0 0 0 26.262 2h-6.524Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M76.206 44.726A2.5 2.5 0 0 1 73.716 47h-5.434a2.5 2.5 0 0 1-2.49-2.274l-.545-6A2.5 2.5 0 0 1 67.737 36h6.525a2.5 2.5 0 0 1 2.49 2.726l-.546 6Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M74.262 46c.686 0 1.314-.388 1.62-1.002l.223-.445a1 1 0 1 1 1.79.894l-.223.445A3.813 3.813 0 0 1 74.262 48h-6.524a3.812 3.812 0 0 1-3.41-2.108l-.223-.445a1 1 0 1 1 1.79-.894l.222.445A1.812 1.812 0 0 0 67.738 46h6.524Z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M92.206 44.726A2.5 2.5 0 0 1 89.716 47h-5.434a2.5 2.5 0 0 1-2.49-2.274l-.545-6A2.5 2.5 0 0 1 83.737 36h6.525a2.5 2.5 0 0 1 2.49 2.726l-.546 6Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M90.262 46c.686 0 1.314-.388 1.62-1.002l.223-.445a1 1 0 1 1 1.79.894l-.223.445A3.813 3.813 0 0 1 90.262 48h-6.524a3.812 3.812 0 0 1-3.41-2.108l-.223-.445a1 1 0 1 1 1.79-.894l.222.445A1.812 1.812 0 0 0 83.738 46h6.524Z",
  clipRule: "evenodd"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M33.794 3.274A2.5 2.5 0 0 1 36.284 1h5.434a2.5 2.5 0 0 1 2.49 2.274l.545 6A2.5 2.5 0 0 1 42.263 12H35.74a2.5 2.5 0 0 1-2.49-2.726l.545-6Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M35.738 2c-.686 0-1.314.388-1.62 1.002l-.223.445a1 1 0 1 1-1.79-.894l.223-.446A3.813 3.813 0 0 1 35.738 0h6.524c1.444 0 2.764.816 3.41 2.107l.223.446a1 1 0 1 1-1.79.894l-.222-.445A1.812 1.812 0 0 0 42.262 2h-6.524Z",
  clipRule: "evenodd"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M60.206 44.726A2.5 2.5 0 0 1 57.716 47h-5.434a2.5 2.5 0 0 1-2.49-2.274l-.545-6A2.5 2.5 0 0 1 51.737 36h6.524a2.5 2.5 0 0 1 2.49 2.726l-.545 6Z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M58.262 46c.686 0 1.314-.388 1.62-1.002l.223-.445a1 1 0 1 1 1.79.894l-.223.445A3.813 3.813 0 0 1 58.262 48h-6.524a3.812 3.812 0 0 1-3.41-2.108l-.223-.445a1 1 0 1 1 1.79-.894l.222.445A1.812 1.812 0 0 0 51.738 46h6.524Z",
  clipRule: "evenodd"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M49.794 3.274A2.5 2.5 0 0 1 52.284 1h5.434a2.5 2.5 0 0 1 2.49 2.274l.545 6A2.5 2.5 0 0 1 58.263 12H51.74a2.5 2.5 0 0 1-2.49-2.726l.545-6Z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M51.738 2c-.686 0-1.314.388-1.62 1.002l-.223.445a1 1 0 1 1-1.79-.894l.223-.446A3.813 3.813 0 0 1 51.738 0h6.524c1.444 0 2.764.816 3.41 2.107l.223.446a1 1 0 1 1-1.79.894l-.222-.445A1.812 1.812 0 0 0 58.262 2h-6.524Z",
  clipRule: "evenodd"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M44.206 44.726A2.5 2.5 0 0 1 41.716 47h-5.434a2.5 2.5 0 0 1-2.49-2.274l-.545-6A2.5 2.5 0 0 1 35.737 36h6.524a2.5 2.5 0 0 1 2.49 2.726l-.545 6Z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M42.262 46c.686 0 1.314-.388 1.62-1.002l.223-.445a1 1 0 1 1 1.79.894l-.223.445A3.813 3.813 0 0 1 42.262 48h-6.524a3.812 3.812 0 0 1-3.41-2.108l-.223-.445a1 1 0 1 1 1.79-.894l.222.445A1.812 1.812 0 0 0 35.738 46h6.524Z",
  clipRule: "evenodd"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M65.794 3.274A2.5 2.5 0 0 1 68.284 1h5.434a2.5 2.5 0 0 1 2.49 2.274l.545 6A2.5 2.5 0 0 1 74.263 12h-6.525a2.5 2.5 0 0 1-2.49-2.726l.546-6Z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M67.738 2c-.686 0-1.314.388-1.62 1.002l-.223.445a1 1 0 1 1-1.79-.894l.223-.446A3.813 3.813 0 0 1 67.738 0h6.524c1.444 0 2.764.816 3.41 2.107l.223.446a1 1 0 1 1-1.79.894l-.222-.445A1.812 1.812 0 0 0 74.262 2h-6.524Z",
  clipRule: "evenodd"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M81.794 3.274A2.5 2.5 0 0 1 84.284 1h5.434a2.5 2.5 0 0 1 2.49 2.274l.545 6A2.5 2.5 0 0 1 90.263 12h-6.525a2.5 2.5 0 0 1-2.49-2.726l.546-6Z"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M83.738 2c-.686 0-1.314.388-1.62 1.002l-.223.445a1 1 0 1 1-1.79-.894l.223-.446A3.813 3.813 0 0 1 83.738 0h6.524c1.444 0 2.764.816 3.41 2.107l.223.446a1 1 0 1 1-1.79.894l-.222-.445A1.812 1.812 0 0 0 90.262 2h-6.524Z",
  clipRule: "evenodd"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M28.206 44.726A2.5 2.5 0 0 1 25.716 47h-5.434a2.5 2.5 0 0 1-2.49-2.274l-.545-6A2.5 2.5 0 0 1 19.737 36h6.525a2.5 2.5 0 0 1 2.49 2.726l-.546 6Z"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M26.262 46c.686 0 1.314-.388 1.62-1.002l.223-.445a1 1 0 1 1 1.79.894l-.223.445A3.813 3.813 0 0 1 26.262 48h-6.524a3.812 3.812 0 0 1-3.41-2.108l-.223-.445a1 1 0 1 1 1.79-.894l.222.445A1.812 1.812 0 0 0 19.738 46h6.524Z",
  clipRule: "evenodd"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M104.726 18.793a2.5 2.5 0 0 1 2.274 2.49v5.434a2.5 2.5 0 0 1-2.274 2.49l-6 .545A2.5 2.5 0 0 1 96 27.262v-6.524a2.5 2.5 0 0 1 2.726-2.49l6 .545Z"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M106 20.738c0-.686-.388-1.314-1.002-1.62l-.445-.223a1 1 0 0 1 .894-1.79l.446.223a3.813 3.813 0 0 1 2.107 3.41v6.524a3.813 3.813 0 0 1-2.107 3.41l-.446.223a1 1 0 1 1-.894-1.79l.445-.222A1.813 1.813 0 0 0 106 27.262v-6.524Z",
  clipRule: "evenodd"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M3.274 29.207A2.5 2.5 0 0 1 1 26.717v-5.433a2.5 2.5 0 0 1 2.274-2.49l6-.546A2.5 2.5 0 0 1 12 20.738v6.525a2.5 2.5 0 0 1-2.726 2.49l-6-.546Z"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M2 27.262c0 .687.388 1.314 1.002 1.621l.445.223a1 1 0 0 1-.894 1.789l-.446-.223A3.813 3.813 0 0 1 0 27.262v-6.524c0-1.444.816-2.764 2.107-3.41l.446-.222a1 1 0 0 1 .894 1.789l-.445.222A1.813 1.813 0 0 0 2 20.738v6.524Z",
  clipRule: "evenodd"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M13.998 16.5c0-1.38 1.4-2.5 3.125-2.5h73.75c1.726 0 3.125 1.12 3.125 2.5v15c0 1.38-1.4 2.5-3.125 2.5h-73.75c-1.726 0-3.125-1.12-3.125-2.5v-15Z"
})));
SvgRectangle124A.viewBox = '0 0 108 48';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle124A);
export default ForwardRef;